import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-6 py-24 sm:py-32 lg:px-8">
      <div className="text-center">
        {/* Katta 404 matni */}
        <p className="text-6xl font-bold text-[#7C3AED]">404</p>
        
        <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
          Sahifa topilmadi
        </h1>
        
        <p className="mt-6 text-base leading-7 text-gray-600">
          Kechirasiz, siz qidirayotgan sahifa mavjud emas yoki ko'chirib o'tilgan.
        </p>

        {/* Aloqa va qaytish tugmalari */}
        <div className="mt-10 flex items-center justify-center gap-x-6">
          <Link
            to="/"
            className="rounded-xl bg-[#7C3AED] px-6 py-3 text-sm font-semibold text-white shadow-sm hover:bg-[#6D28D9] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#7C3AED] transition-all"
          >
            Asosiy sahifaga qaytish
          </Link>
          
          <a 
            href="mailto:asadbekxojaboyev0@mail.com" 
            className="text-sm font-semibold text-gray-900 hover:text-[#7C3AED] transition-colors"
          >
            Yordam kerakmi? <span aria-hidden="true">&rarr;</span>
          </a>
        </div>
      </div>

      {/* Saytingdagi kabi pastki qismda mayda ma'lumotlar (ixtiyoriy) */}
      <div className="mt-16 text-sm text-gray-400 border-t border-gray-100 pt-8 w-full max-w-xs text-center">
        DevCore • TKTI Dasturlash Kurslari
      </div>
    </div>
  );
};

export default NotFound;